import React from "react"

const Fire = ({ width = "60", height = "68", viewBox = "0 0 60 68" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a-fire-icon)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.994 52c-.233 0-.469-.006-.704-.017-8.198-.412-14.295-8.198-13.152-16.512.607-4.406 2.833-7.925 5.133-10.24.31-.31.719-.454 1.126-.454.837 0 1.663.607 1.583 1.612-.345 4.342 1.734 6.506 1.734 6.506s6.248-5.946 3.382-14.84c-.362-1.122.48-2.055 1.487-2.055.276 0 .564.07.844.226 3.558 1.985 7.246 5.765 8.954 8.614C42.756 28.796 44 33.055 44 37.672 44 45.585 37.729 52 29.994 52Z"
          fill="#DB1616"
        />
      </g>
      <defs>
        <filter
          id="a-fire-icon"
          x="-10"
          y="-6"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix values="0 0 0 0 0.766667 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default Fire
